module.exports = __webpack_public_path__ + "static/img/bg.397dc7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bg.png
// module id = fZ9+
// module chunks = 70